import React from 'react';

import { Camera } from '@zola/zola-ui/src/assets/images/icons';

import {
  Container,
  Icon,
  Label,
  NoEntityContainer,
  StyledButton,
  Title,
} from './MultiPhotoCta.styles';

type MultiPhotoCtaProps = {
  handleToggleMultiPhotoModal: () => void;
  isDisabled?: boolean;
  ctaOverrideTxt?: {
    titleTxt?: string;
    labelTxt?: string;
    btnTxt?: string;
  };
};

const MultiPhotoCta: React.FC<MultiPhotoCtaProps> = ({
  handleToggleMultiPhotoModal,
  isDisabled,
  ctaOverrideTxt,
}) => {
  return (
    <Container>
      <Title>{ctaOverrideTxt?.titleTxt || 'Photos'}</Title>
      <NoEntityContainer>
        <Icon src={Camera} alt="Camera icon" />
        <Label>
          {ctaOverrideTxt?.labelTxt || 'Fact: The more photos you share, the happier the guests.'}
        </Label>
        <StyledButton
          variant="secondary"
          onClick={handleToggleMultiPhotoModal}
          disabled={isDisabled}
        >
          {ctaOverrideTxt?.btnTxt || 'Browse Photos'}
        </StyledButton>
      </NoEntityContainer>
    </Container>
  );
};

export default MultiPhotoCta;
